var map = {
	"./Accounts/Accounts.route.ts": 829,
	"./Accounts/EditAccounts.route.ts": 830,
	"./Airdrop/Airdrop.route.tsx": 831,
	"./Auth/Auth.route.ts": 832,
	"./Collections/Collection.list.route.tsx": 833,
	"./Collections/Collections.details.route.tsx": 834,
	"./Collections/Marketplace.route.tsx": 835,
	"./Collections/NFTDetails.route.tsx": 836,
	"./CreateCollections/CreateCollections.route.tsx": 837,
	"./CreateCollections/EditCollections.route.tsx": 838,
	"./CurrentMinting/CurrentMinting.route.tsx": 839,
	"./Home/Home.route.tsx": 840,
	"./MintingDetail/MintingDetail.route.tsx": 841,
	"./ShareToEarn/ShareToEarn.route.tsx": 842,
	"./WaitList/WaitList.route.tsx": 843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 828;